import { render, staticRenderFns } from "./UserAccounts.vue?vue&type=template&id=0144de28&scoped=true&"
import script from "./UserAccounts.vue?vue&type=script&lang=js&"
export * from "./UserAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0144de28",
  null
  
)

export default component.exports